import './App.css';
import Calculator from './Components/Calculator'

function App() {
  return (
    <div className="table">
      <section className="books">
        <Calculator /> 
      </section>
    
    </div>
  );
}

export default App;
